import { render } from "./DraftBillsHistoryPanel.vue?vue&type=template&id=1b7af75b&scoped=true"
import script from "./DraftBillsHistoryPanel.vue?vue&type=script&lang=js"
export * from "./DraftBillsHistoryPanel.vue?vue&type=script&lang=js"

import "./DraftBillsHistoryPanel.vue?vue&type=style&index=0&id=1b7af75b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7af75b"]])

export default __exports__